import { Box, IconButton, Modal, Tooltip, useMediaQuery } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getBaseUrl } from "../features/ImageSuite/Helper";
import { tooltipStyles } from "../features/TextSuite/Components/TextSuitesBody";
import DoneIcon from "@mui/icons-material/Done";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  width: "35%",
  minWidth: "410px",
  height: "260px",
  position: "absolute",
  borderRadius: "12px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "var(--sub_background6)",
  outline: "none",
};

interface SharePopupProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  sharingLink: string;
}

export const SharePopup = ({
  show,
  handleClose,
  title,
  sharingLink,
}: SharePopupProps) => {
  const [isTitleCoped, setIsTitleCoped] = useState(false);
  const [titleCoped, setTitleCoped] = useState("");
  const responsiveSize = useMediaQuery("(max-width: 700px)");

  const handleCopySharingLink = (link: string) => {
    const baseUrl = window.origin + link;
    navigator.clipboard.writeText(baseUrl);
    setIsTitleCoped(true);
    setTitleCoped(title);
    setTimeout(() => {
      setIsTitleCoped(false);
    }, 1000);
  };

  return (
    <Modal
      open={show}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...containerStyle }} className="share-modal-body">
        <Box className="share-modal-popup-header">
          <Box className="header-titles">
            <p>{title}</p>
          </Box>
          <IconButton onClick={handleClose}>
            <Close
              sx={{
                color: "var(--Main_icons_color)",
                fontSize: "24px",
              }}
            />
          </IconButton>
        </Box>
        <Box className="share-modal-popup-body">
          <Box className="sharing-message">
            <InfoOutlinedIcon sx={{ opacity: "0.7" }} />
            <p>
              Don’t share personal or confidential information.
              <br /> Public links can be reshared with anyone.
            </p>
          </Box>

          <Box className="sharing-link-container">
            <Box className="share-link">
              {sharingLink && window.origin + sharingLink}
            </Box>
            <Box className="copy-share-link">
              <IconButton
                color="inherit"
                size="small"
                onClick={() => handleCopySharingLink(sharingLink)}
              >
                <IconButton color="inherit" size="small">
                  <Tooltip
                    disableHoverListener={responsiveSize}
                    disableFocusListener={responsiveSize}
                    disableTouchListener={responsiveSize}
                    title={isTitleCoped ? "Copied" : "Copy"}
                    arrow
                    placement="top"
                    componentsProps={tooltipStyles}
                  >
                    {isTitleCoped && title === titleCoped ? (
                      <DoneIcon sx={{ color: "#12B6EA", width: "22px" }} />
                    ) : (
                      <ContentCopyIcon
                        sx={{ color: "#12B6EA", width: "22px" }}
                      />
                    )}
                  </Tooltip>
                </IconButton>
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
